module.exports = __webpack_public_path__ + "img/icon_right.2ddff6d2.svg";